import { Component } from "react"
import API, { URL_PATH } from "../../services/API"
import redux from "../../common/Redux"
import routes from "../../routes/URL"
import {
  Container,
  Typography,
  Box,
  TextField,
  Button,
  Grid,
  Card,
  CardContent,
  CardHeader,
  IconButton,
} from "@mui/material"
import DeleteIcon from "@mui/icons-material/Delete"
import IsolatedStatusModal from "../../components/StatusModal"
import Toast from "../../components/Toast"
import Header from "../../components/Header"
import { CustomDatePicker } from "../../components/CustomDatePicker"

class CreateEmployeeScreen extends Component {
  constructor(props) {
    super(props)
    this.state = {
      active: 1,
      profile_pic: null,
      government_id: null,
      toast: {
        open: false,
        message: "",
        severity: "success"
      }
    }
  }

  showToast = (message, severity = "success") => {
    this.setState({
      toast: {
        open: true,
        message,
        severity
      }
    });
  }

  handleCloseToast = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    this.setState({
      toast: {
        ...this.state.toast,
        open: false
      }
    });
  }

  handleFileChange = (event, fileType) => {
    const file = event.target.files[0]
    if (file) {
      this.setState({ [fileType]: file })
    }
  }

  handleFileDelete = (fileType) => {
    this.setState({ [fileType]: null })
  }

  create = async (event) => {
    event.preventDefault()
    const fd = new FormData(event.target)
    fd.append("status", this.state.active)
    const { status, message, data } = await API(this, "post", URL_PATH.createEmployee, fd)
    if (status == "success") {
      // Replace window.Alert with state update for success modal
      this.showToast(message, "success");
      this.props.history.push(routes.admin.employees.root(this.props.hotels[0]?.hotel_slug || ''))

    } else {
      // Replace window.Alert with state update for error modal
      this.showToast(message, "error");
    }
  }

  handleSuccessModalClose = () => {
    // Close success modal and redirect
    this.setState({ showSuccessModal: false })
    this.props.history.push(routes.admin.employees.list(this.props.hotels[0]?.hotel_slug || ''))
  }

  handleErrorModalClose = () => {
    // Close error modal
    this.setState({ showErrorModal: false })
  }
    componentDidMount() {
       const hotel = this.props.hotels.find(h => h.hotel_slug === this.props.match.params.hotelSlug);
    if (!hotel) {
        this.props.history.push(routes.admin.dashboard.root(this.props.hotels[0]?.hotel_slug || ''));
        return;
    }
  }

  renderFileUpload = (fileType, label) => {
    const file = this.state[fileType]
    return (
      <Box sx={{ height: "100%" }}>
        <Typography variant="subtitle1" color="text.secondary" gutterBottom>
          {label}
        </Typography>
        <Box
          sx={{
            height: "calc(100% - 24px)", // Subtracting the height of the Typography
            border: "1px dashed rgba(255, 255, 255, 0.23)",
            borderRadius: "8px",
            p: 2,
            textAlign: "center",
            cursor: "pointer",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <input
            type="file"
            id={fileType}
            name={fileType}
            accept="image/*"
            style={{ display: "none" }}
            onChange={(e) => this.handleFileChange(e, fileType)}
          />
          {file ? (
            <Box display="flex" alignItems="center" justifyContent="space-between" width="100%">
              <Typography noWrap>{file.name}</Typography>
              <IconButton onClick={() => this.handleFileDelete(fileType)} size="small">
                <DeleteIcon />
              </IconButton>
            </Box>
          ) : (
            <label
              htmlFor={fileType}
              style={{
                cursor: "pointer",
                height: "100%",
                width: "100%",
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  gap: 1,
                }}
              >
                <Box
                  sx={{
                    width: "40px",
                    height: "40px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    border: "1px dashed rgba(255, 255, 255, 0.23)",
                    borderRadius: "4px",
                    mb: 1,
                  }}
                >
                  <svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-7" />
                    <polyline points="17 8 12 3 7 8" />
                    <line x1="12" y1="3" x2="12" y2="15" />
                  </svg>
                </Box>
                <Typography>Upload a file</Typography>
                <Typography variant="caption" color="text.secondary">
                  PNG, JPG, GIF, PDF up to 1.0MB
                </Typography>
              </Box>
            </label>
          )}
        </Box>
      </Box>
    )
  }

  render() {
    return (
      <Container maxWidth="lg">


        <Card sx={{ mb: 3, backgroundColor: "#02111B", backgroundImage: "none", border: "1px solid #FFC857" }}>
          {/* <CardHeader title="Employee Details" /> */}
          <CardHeader
            title={
              <Header title="Employee Details" />

            }
            sx={{ pb: 2 }}
          />
          <CardContent>
            <form id="employeeForm" onSubmit={this.create}>
              <Grid container spacing={3}>
                <Grid item xs={12} sm={6}>
                  {this.renderFileUpload("profile_pic", "Profile Picture")}
                </Grid>
                <Grid item xs={12} sm={6}>
                  {this.renderFileUpload("government_id", "Government ID")}
                </Grid>

                <Grid item xs={12} sm={6}>
                  <TextField
                    fullWidth
                    label="Employee Name"
                    name="name"
                    id="employee_name"
                    placeholder="Enter Employee Name"
                    required
                    sx={{ mb: 2 }}
                  />

                  <TextField
                    fullWidth
                    label="Email"
                    name="email"
                    id="employee_email"
                    type="email"
                    placeholder="Email id"
                    required
                    sx={{ mb: 2 }}
                  />

                  <TextField
                    fullWidth
                    label="Phone Number"
                    name="phone"
                    type="number"
                    id="employee_price"
                    placeholder="Phone Number"
                    required
                    sx={{ mb: 2 }}
                  />
                  <CustomDatePicker
                    fullWidth
                    label="Date of Birth"
                    placeholder="dd-mm-yyyy"
                    name="dob"
                    id="employee_image"
                    InputLabelProps={{ shrink: true }}
                    required
                    sx={{ mb: 2 }}
                  />
                </Grid>

                <Grid item xs={12} sm={6}>
                  <TextField
                    fullWidth
                    label="Designation"
                    name="designation"
                    placeholder="Employee Designation"
                    required
                    sx={{ mb: 2 }}
                  />

                  <CustomDatePicker
                    fullWidth
                    label="Hired Date"
                    placeholder="dd-mm-yyyy"
                    
                    name="date_hired"
                    InputLabelProps={{ shrink: true }}
                    required
                    sx={{ mb: 2 }}
                  />

                  <TextField
                    fullWidth
                    label="Education"
                    name="education"
                    placeholder="Employee Education"
                    required
                    sx={{ mb: 2,mt: 2 }}
                  />
                  <TextField
                    fullWidth
                    label="Address"
                    name="address"
                    placeholder="Employee Address"
                    required
                    sx={{ mb: 2 }}
                  />
                </Grid>
              </Grid>

              <Box sx={{ mt: 3, display: "flex", justifyContent: "flex-start" }}>
                <Button
                  type="submit"
                  variant="contained"
                  sx={{
                    bgcolor: "#FFC857",
                    fontWeight: "700",
                    "&:hover": { bgcolor: "#E6B54E" },
                  }}
                >
                  Submit
                </Button>
              </Box>
            </form>
          </CardContent>
        </Card>

        <Toast
          open={this.state.toast.open}
          message={this.state.toast.message}
          severity={this.state.toast.severity}
          handleClose={this.handleCloseToast}
        />
      </Container>
    )
  }
}

export default redux(CreateEmployeeScreen)